<template>
  <div>
    <!-- 画像アップロード -->
    <el-form label-position="top">
      <el-form-item label="会社情報"> </el-form-item>
    </el-form>

    <el-divider />

    <!-- 日本語 & 英語 タイトルと内容 -->
    <el-row :gutter="20">
      <el-col :span="12">
        <h3>日本語</h3>
        <el-form label-position="top">
          <el-form-item label="会社名（商号）">
            <el-input
              v-model="form.company_name_ja"
              type="textarea"
              :rows="2"
              required
            />
          </el-form-item>
          <el-form-item label="本社＆拠点">
            <el-input
              v-model="form.headquarters_and_offices_ja"
              type="textarea"
              :rows="5"
              required
            />
          </el-form-item>
          <el-form-item label="海外オフィス">
            <el-input
              v-model="form.overseas_offices_ja"
              type="textarea"
              :rows="5"
              required
            />
          </el-form-item>
          <el-form-item label="決算期">
            <el-input
              v-model="form.fiscal_year_ja"
              type="textarea"
              :rows="2"
              required
            />
          </el-form-item>
          <el-form-item label="事業内容">
            <el-input
              v-model="form.business_content_ja"
              type="textarea"
              :rows="5"
              required
            />
          </el-form-item>
          <el-form-item label="所在地">
            <el-input
              v-model="form.address_ja"
              type="textarea"
              :rows="3"
              required
            />
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span="12">
        <h3>英語</h3>
        <el-form label-position="top">
          <el-form-item label="Company Name">
            <el-input
              v-model="form.company_name_en"
              type="textarea"
              :rows="2"
              required
            />
          </el-form-item>
          <el-form-item label="Headquarters & Branches">
            <el-input
              v-model="form.headquarters_and_offices_en"
              type="textarea"
              :rows="5"
              required
            />
          </el-form-item>
          <el-form-item label="Overseas Offices">
            <el-input
              v-model="form.overseas_offices_en"
              type="textarea"
              :rows="5"
              required
            />
          </el-form-item>
          <el-form-item label="Fiscal Year">
            <el-input
              v-model="form.fiscal_year_en"
              type="textarea"
              :rows="2"
              required
            />
          </el-form-item>
          <el-form-item label="Business Content">
            <el-input
              v-model="form.business_content_en"
              type="textarea"
              :rows="5"
              required
            />
          </el-form-item>
          <el-form-item label="Address">
            <el-input
              v-model="form.address_en"
              type="textarea"
              :rows="3"
              required
            />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-divider />

    <!-- 保存ボタン -->
    <el-button type="primary" @click="confirmSave">保存</el-button>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { supabase } from "@/supabase.js"; // Supabase 连接

export default {
  setup() {
    const form = ref({});

    const fetchData = async () => {
      const { data, error } = await supabase
        .from("company_info")
        .select(
          " * ")
        .eq("id", "company_info")
        .single();

      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        form.value = data;
      }
    };

    // 📌 保存数据
    const saveData = async () => {
      if (
        !form.value.company_name_ja ||
        !form.value.company_name_en ||
        !form.value.headquarters_and_offices_ja ||
        !form.value.headquarters_and_offices_en ||
        !form.value.overseas_offices_ja ||
        !form.value.overseas_offices_en ||
        !form.value.fiscal_year_ja ||
        !form.value.fiscal_year_en ||
        !form.value.business_content_ja ||
        !form.value.business_content_en ||
        !form.value.address_ja ||
        !form.value.address_en
      ) {
        ElMessage.error("全ての項目を入力してください。");
        return;
      }

      // 更新 `home_info` 表
      const { error } = await supabase
        .from("company_info")
        .update(form.value)
        .eq("id", "company_info");

      if (error) {
        console.error("データ保存エラー:", error);
        ElMessage.error("保存に失敗しました。");
      } else {
        ElMessage.success("データを保存しました。");
      }
    };

    // 📌 确认保存对话框
    const confirmSave = () => {
      ElMessageBox.confirm("この内容で保存しますか？", "確認", {
        confirmButtonText: "保存",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          saveData();
        })
        .catch(() => {
          ElMessage.info("保存をキャンセルしました。");
        });
    };

    onMounted(fetchData);

    return {
      form,
      confirmSave,
    };
  },
};
</script>
<style lang="stylus" scoped>
.uploaded-image {
  height: 150px; /* 只控制高度 */
  width: auto; /* 宽度自适应 */
  object-fit: contain; /* 保持原比例，不裁剪 */
  border-radius: 8px; /* 圆角 */
  display: block;
  max-width: 100%; /* 防止超出父容器 */
}
:deep(.el-upload--picture-card) {
    --el-upload-picture-card-size: 148px;
    align-items: center;
    background-color: var(--el-fill-color-lighter);
    border: 1px dashed var(--el-border-color-darker);
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    height: var(--el-upload-picture-card-size);
    justify-content: center;
    vertical-align: top;
    width: 300px;
}
</style>
